import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Input, Typography } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";

const { Option } = Select;

const GoodsDamageForm = props => {
    const { t } = useTranslation();
    const [goodsTypes, setGoodsTypes] = useState([]);
    const [unitTypes, setUnitTypes] = useState([]);
    const [form] = Form.useForm();

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/transport/enums/goods")
            .then(({ data }) => {
                setGoodsTypes(data);
            })
            .catch(function (error) {
                console.log(error);
            });
        axios
            .get(process.env.REACT_APP_API_ENDPOINT + "/transport/enums/units")
            .then(({ data }) => {
                setUnitTypes(data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                good: props.record.damage.good,
                quantity: props.record.damage.quantity,
                unit: props.record.damage.unit,
            });
        }
    }, [props.record.damage, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        const newDamage = { ...props.record };
        newDamage.damage.good = elvis(allValues.good);
        newDamage.damage.quantity = elvis(allValues.quantity);
        newDamage.damage.unit = elvis(allValues.unit);
        newDamage.damage.damageClass = props.damageClass;
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newDamage.valid = true;
                props.parentCallback(newDamage);
            })
            .catch(() => {
                newDamage.valid = false;
                props.parentCallback(newDamage);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="goodsDamageForm"
        >
            <Form.Item label="Category" name="good">
                <Select>
                    {goodsTypes.map(name => (
                        <Option key={name} value={name}>
                            {t('transportEnums.good.' + name, name)}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item label="Quantification">
                <Input.Group compact>
                    <Form.Item name="quantity" noStyle>
                        <InputNumber />
                    </Form.Item>
                    <Form.Item name="unit" noStyle>
                        <Select style={{ width: '100px' }} placeholder="Select measure">
                            {unitTypes.map(name => (
                                <Option key={name} value={name}>
                                    {t('transportEnums.unit.' + name, name)}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Input.Group>
            </Form.Item>
        </Form>
    );
};

export default GoodsDamageForm;